<template>
	<div class="footer">
		<div class="container">
			<div class="row">
				<div class="hidden-xs hidden-sm footerItem">
					<p class="footertitle">地图</p>
					<div>
						<a href="http://map.ishowchina.com">web地图</a>
					</div>
					<div>
						<a href="http://app.ishowchina.com">移动地图</a>
					</div>
					<div>
						<a href="http://streetview.ishowchina.com/">全景地图</a>
					</div>
				</div>
				<div class="hidden-xs hidden-sm footerItem">
					<p class="footertitle">地图服务</p>
					<div>
						<a href="http://dev.ishowchina.com">地图开放平台</a>
					</div>
					<div>
						<a href="http://www.ishowchina.com/tracecloud.html">轨迹云端管理</a>
					</div>
					<div>
						<a href="http://www.ishowchina.com/cloudmap.html">地图在线制作</a>
					</div>
				</div>
				<div class="hidden-xs hidden-sm footerItem">
					<p class="footertitle">物联网</p>
					<div>
						<a href="http://solution.ishowchina.com/beyond.html">车联网</a>
					</div>
					<div>
						<a href="http://solution.ishowchina.com/citymanage.html">智慧城市</a>
					</div>
					<div>
						<a href="http://solution.ishowchina.com/smartadministor.html">智慧城管</a>
					</div>
					<div>
						<a href="http://solution.ishowchina.com/police.html">公安行业应用</a>
					</div>
				</div>
				<div class="hidden-xs hidden-sm footerItem">
					<p class="footertitle">大数据</p>
					<div>
						<a href="http://solution.ishowchina.com/datademo.html">行业数据</a>
					</div>
					<div>
						<a href="http://www.ishowchina.com/cloudmap.html">数据可视化</a>
					</div>
					<div>
						<a href="http://solution.ishowchina.com/measure.html">地图数据采集</a>
					</div>
					<div>
						<a href="http://datastore.ishowchina.com/index.htm">数据商城</a>
					</div>
				</div>
				<div class="hidden-xs hidden-sm footerItem">
					<p class="footertitle">行业解决方案</p>
					<div>
						<a href="http://solution.ishowchina.com/estate.html">房地产行业解决方案</a>
					</div>
					<div>
						<a href="http://solution.ishowchina.com/bigData.html">大数据行业解决方案</a>
					</div>
					<div>
						<a href="http://solution.ishowchina.com/smartlogistics.html">智慧物流解决方案</a>
					</div>
					<div>
						<a href="http://solution.ishowchina.com/smarttravel.html">智慧旅游解决方案</a>
					</div>
				</div>
				<div class="hidden-xs hidden-sm footerItem">
					<p class="footertitle">关于我们</p>
					<div>
						<a href="http://about.ishowchina.com">关于我们</a>
					</div>
					<div>
						<a href="http://about.ishowchina.com/connect.html">联系我们</a>
					</div>
					<div>
						<a href="http://about.ishowchina.com/legal.html">法律声明</a>
					</div>
					<div>
						<a href="http://about.ishowchina.com/help.html">帮助中心</a>
					</div>
					<div>
						<a href="#" class="userfreeback">意见反馈</a>
					</div>
				</div>
				<div class="footerItem">
					<p class="footertitle">联系我们</p>
					<div class="lxwm">
						<img src="./images/footer/email.png" class="footerIcon" />
						<a href="mailto:bd@leador.com.cn" class="mail">bd@leador.com.cn</a>
					</div>
					<div class="lxwm">
						<img src="./images/footer/tel.png" class="footerIcon" /> 15201338330（同微信）
					</div>
					<div class="lxwm">
						<img src="./images/footer/q.png" class="footerIcon" /> 127817479
					</div>
					<div class="lxwm">
						<img src="./images/footer/adress.png" class="footerIcon address" /> <span class="addressSpan">北京市海淀区中关村军民融合产业园B座106</span>
					</div>

				</div>
				<div class="clearfix visible-sm-block"></div>
				<div class="col-xs-12 footerItem focus_us">
					<div class="row">
						<p class="col-xs-12 qrcode-title footertitle">关注我们</p>
						<div class="qrcode-wrap col-xs-6">
							<a title="微信公众号"> <img src="./images/footer/weixin.jpg">
							</a>
							<p class="wx">我秀地图</p>
						</div>
						<div class="qrcode-wrap col-xs-6">
							<a title="新浪微博"> <img src="./images/footer/xinlang.jpg">
							</a>
							<p class="wx">我秀中国官方微博</p>
						</div>
					</div>
				</div>
			</div>

		</div>

		<div class="clearfix"></div>
		<div class="container-fluid icp">
		<div style="height:40px;line-height: 28px;">版权所有 ©<span id="copy_icp">2018</span>
			北京秀友科技有限公司&nbsp;&nbsp;经营许可证 B2-20090067 2009 ishowchina.com 甲测资字42002001
			<p style="margin:0;padding:0;height:20px;">
				<a target="_blank" href="http://beian.miit.gov.cn/" style="color:#c5c5c5;font-size:14px;cursor: pointer;">京ICP备15012051号-2</a>
			</p>
		</div>
	</div>
	</div>
	
</template>
<style lang="less" rel="stylesheet/less">
	.footer {
		width: 100%;
		padding-top: 50px;
		padding-bottom: 20px;
		padding-left: 20px;
		background: #5f5e5e;
		font-size: 14px;
		color: #c5c5c5;
		overflow: hidden;
		font-family: 'Microsoft Yahei', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif';
		.container {
			padding-left: 325px;
		}
	}
	
	.footer a,
	.footer .lxwm,
	.footer .wx {
		color: #cecece;
		font-size: 14px;
		line-height: 24px;
	}
	
	.footer .mail {
		text-decoration: underline;
		padding-left: 0;
	}
	
	.footer a:hover {
		color: #fff;
		cursor: pointer;
		text-decoration: underline;
	}
	
	.footer p {
		font-size: 18px;
		margin-bottom: 30px;
	}
	
	.icp {
		background: #5f5e5e;
		text-align: center;
		border-top: 1px solid #4c4c4c;
		color: #c5c5c5;
		vertical-align: middle;
		padding-top: 20px;
		padding-bottom: 10px;
		clear: both;
	}
	
	.icp div {
		font-size: 14px;
		height: 24px;
		line-height: 24px;
		text-align: center;
	}
	
	.qrcode-wrap {
		text-align: center;
		padding: 0;
		width: 140px;
		float: left;
		img {
			width: 94px;
		}
		p {
			margin-bottom: 0;
			margin-top: 5px;
		}
	}
	
	.footerItem {
		float: left;
		margin-right: 16px;
		font-family: '微软雅黑';
		.footertitle {
			font-size: 16px;
			color: #fff;
			font-weight: bold;
		}
		.footerIcon {
			margin-right: 5px;
		}
		.footerIcon.address {
			position: absolute;
			margin-top: 5px;
		}
		.addressSpan {
			float: right;
			margin-left: 24px;
		}
		.qrcode-title {
			margin-left: 20px;
		}
	}
	
	.footerItem.focus_us {
		padding: 0;
		margin-bottom:40px;
	}
	@media(max-width:1650px){
		.footer .container{
			padding-left:165px;
		}
	}
	@media(max-width:1440px){
		.footer .container{
			padding-left:90px;
		}
	}
	@media(max-width:1366px){
		.footer .container{
			padding-left:40px;
		}
	}
	@media(max-width:1024px){
		.footer .container{
			padding-left:197px;
		}
	}
	@media(max-width:768px) {
		.footer {
			height: 400px;
		}
		.icp {
			padding-bottom: 70px;
		}
		.footerItem {
			max-width: 100%;
			padding-left: 0;
		}
		.footerItem.focus_us {
			margin-top: 15px;
			.footertitle {
				padding-left: 0;
			}
		}
	}
</style>
<script>
	import contactUs from './../contactUs.vue'
	export default {
		components: {
			'contact-us': contactUs
		}
	}
</script>


// WEBPACK FOOTER //
// footer.vue?0d5eb028